























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { ALL_SUBUNITS } from '@/queries/SubUnit';
import { GQL_currentUnitSubUnits_currentUnit_subUnits, GQL_currentUnitSubUnits } from '@/queries/__generated__/currentUnitSubUnits';
import { GQL_deleteSubUnit_deleteSubUnit_subUnit } from '@/queries/__generated__/deleteSubUnit';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from 'graphql-tag';

const DELETE_SUBUNIT = gql`
  mutation deleteSubUnit($id: ID!) {
    deleteSubUnit(
      input: {
      id: $id,
    }
    ) {
      subUnit {
        id
      }
    }
  }
`;

@Component
export default class SubUnitDeleteButton extends Vue {
  @Prop() private subUnit!: GQL_currentUnitSubUnits_currentUnit_subUnits;
  private DELETE_SUBUNIT = DELETE_SUBUNIT;

  @Emit('sub-unit-deleted')
  private removeFromCache(
    store: InMemoryCache,
    { data: { deleteSubUnit: { subUnit } } }: {data: {deleteSubUnit: {subUnit: GQL_deleteSubUnit_deleteSubUnit_subUnit}} },
  ) {
    const data = (store.readQuery({ query: ALL_SUBUNITS }) as GQL_currentUnitSubUnits);
    data.currentUnit.subUnits = data.currentUnit.subUnits.filter(s => s.id !== subUnit.id);
    store.writeQuery({ query: ALL_SUBUNITS, data });
  }

  private confirmDelete(confirmMutation: () => {}) {
    this.$sPopup.confirm(``, {
      title: this.$t('PopupTitle.confirmDelete'),
      message: this.$t('PopupBody.confirmDelete', { thing: this.subUnit.name }),
      onConfirm: confirmMutation,
    });
  }
}
